<!--
  @component AuditLayout
  @description Layout del módulo de auditoría.
-->
<template>
  <div class="audit-layout">
    <router-view />
  </div>
</template>

<script>
/**
 * @component AuditLayout
 * @description Layout del módulo de auditoría. Wrapper con padding y tipografía.
 */
export default {
  name: "AuditLayout",
};
</script>

<style scoped>
.audit-layout {
  font-family: "Plus Jakarta Sans", sans-serif;
}
</style>
